<div class="mp-page">

  <!-- Header -->
  <header class="mp-page__header">
    <div class="mp-page__header-left">
      <div class="mp-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      </div>
      <div>
        <h1 class="mp-page__title">Modes de passation de marchés</h1>
        <p class="mp-page__desc">Gérez les modes de passation de marchés de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter un mode"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      [routerLink]="[
        '/',
        routeAlias.parameters.home,
        routeAlias.parameters.marches.home,
        routeAlias.parameters.marches.mode_passation_marches.home,
        routeAlias.parameters.marches.mode_passation_marches.add
      ]"
    ></app-ui-button>
  </header>

  <!-- Card / Table -->
  <div class="mp-card">
    @if (isLoading) {
      <div class="mp-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="mp-card__toolbar">
        <div class="mp-card__toolbar-left">
          <span class="mp-badge">{{ modePassationMarches.length }}</span>
          <span class="mp-card__count">
            enregistrement{{ modePassationMarches.length > 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      @if (!modePassationMarches.length) {
        <div class="mp-empty">
          <div class="mp-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/>
            </svg>
          </div>
          <p class="mp-empty__title">Aucun mode de passation</p>
          <p class="mp-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table
          [columns]="tableMode"
          [data]="modePassationMarches"
          [actions]="rowActions"
        />
      }
    }
  </div>

  <!-- Row actions template -->
  <ng-template #rowActions let-item="item">
    <div class="mp-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        [routerLink]="[
          '/',
          routeAlias.parameters.home,
          routeAlias.parameters.marches.home,
          routeAlias.parameters.marches.mode_passation_marches.home,
          routeAlias.parameters.marches.mode_passation_marches.edit,
          item.id
        ]"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</div>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>